import cookie from 'react-cookies';

import { PROVIDER_ID_COOKIE } from '@r1-frontend/survey/context/constants';
import { SurveyName } from '@r1-frontend/survey/context/surveys';

import { ACCESS_TOKEN_COOKIE } from '@r1-frontend/shared/constants';

import { retrieveCommonSurvey } from './retrieveCommonSurvey';
import { retrieveContextSurvey } from './retrieveContextSurvey';

/**
 * Получение необходимого опроса
 *
 * @param {?import('../surveys').SurveyName} [name] - название опроса (если указан, то ищет среди контекстных опросов)
 * @returns {import('../surveys').SurveyItem | undefined} возвращает нужный опрос (или undefined, если нужный опрос не найден)
 */
export const retrieveSurvey = (name?: SurveyName) => {
    const accessToken = cookie.load(ACCESS_TOKEN_COOKIE);
    const providerId = cookie.load(PROVIDER_ID_COOKIE);
    const page = window.location.pathname;

    const withAuth = Boolean(accessToken);

    if (name) {
        return retrieveContextSurvey({ name, providerId, page, withAuth });
    }

    return retrieveCommonSurvey({ providerId, page, withAuth });
};
